import './styles/index.scss';
import analytics from './analytics';
import footer from './partials/footer/footer';
import header from './partials/header/header';
import booster from './booster';

export default function(pages) {
  header(pages)
  footer()
  analytics()
}



// WEBPACK FOOTER //
// ./src/index.js